var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "vks-anno-workspace-track" },
    [
      _vm.annotations.length
        ? _c(
            "p",
            { staticClass: "vks-anno-workspace-guide" },
            [
              _vm.isAnnotationsOverview
                ? [
                    _vm._v(" Global enrichment by annotation type for "),
                    _vm.showGePlotTitles
                      ? [_vm._v(" each phenotype on the canvas ")]
                      : [_vm._v(" the searched phenotype and locus ")],
                    _vm._v(
                      " . Tabs list annotation types that have tissues shown under "
                    ),
                    _c("strong", [_vm._v("Global enrich. → Tissues")]),
                    _vm._v(". Use "),
                    _c("strong", [_vm._v("Select tissue")]),
                    _vm._v(" on a plot point to load biosample tracks. "),
                  ]
                : [
                    _vm._v(
                      " Tracks show tissues with enrichment p < " +
                        _vm._s(_vm.geTrackPValueMax) +
                        " for the selected annotation "
                    ),
                    _vm.llmRelevanceUsed
                      ? [_vm._v(" that were classified as phenotype-relevant ")]
                      : _vm._e(),
                    _vm._v(" . Open "),
                    _c("strong", [_vm._v("Global enrich.")]),
                    _vm._v(" → "),
                    _c("strong", [_vm._v("Settings / Filters")]),
                    _vm._v(" to adjust the p-value threshold, or "),
                    _c("strong", [_vm._v("Tissues")]),
                    _vm._v(
                      " to re-enable filtered tissues. Optional CS2CT tissue classification is offered in "
                    ),
                    _c("strong", [_vm._v("Assist")]),
                    _vm._v(" as an executable step on the Request tab. "),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm.annotations.length
        ? _c("div", { staticClass: "vks-anno-workspace-tab-bar" }, [
            _c(
              "div",
              {
                staticClass: "vks-anno-workspace-tabs",
                attrs: { role: "tablist", "aria-label": "Annotation tracks" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "vks-anno-workspace-tab vks-anno-workspace-tab--overview",
                    class: { "is-active": _vm.isAnnotationsOverview },
                    attrs: {
                      type: "button",
                      role: "tab",
                      "aria-selected": _vm.isAnnotationsOverview,
                    },
                    on: { click: _vm.showAnnotationsOverview },
                  },
                  [_vm._v(" Annotations ")]
                ),
                _vm._l(_vm.annotationTabs, function (annotation) {
                  return _c(
                    "button",
                    {
                      key: annotation,
                      staticClass: "vks-anno-workspace-tab",
                      class: {
                        "is-active": _vm.isAnnotationTrackActive(annotation),
                      },
                      style: _vm.annotationTabStyle(annotation),
                      attrs: {
                        type: "button",
                        role: "tab",
                        "aria-selected":
                          _vm.isAnnotationTrackActive(annotation),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showAnnotationTrack(annotation)
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.annotationTabLabel(annotation)) + " "
                      ),
                    ]
                  )
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm.isAnnotationsOverview
        ? _c("div", { staticClass: "vks-anno-workspace-overview" }, [
            _c("section", { staticClass: "vks-anno-workspace-legend" }, [
              _c("p", { staticClass: "vks-ui-section-title" }, [
                _vm._v("Annotations"),
              ]),
              _c(
                "ul",
                {
                  staticClass: "vks-ge-legend-list",
                  attrs: { role: "group", "aria-label": "Annotation types" },
                },
                _vm._l(_vm.annotationOptions, function (annotation) {
                  return _c(
                    "li",
                    {
                      key: annotation,
                      staticClass: "vks-ge-legend-item",
                      class: {
                        "is-muted": !_vm.isAnnotationSelected(annotation),
                        "is-empty": !_vm.hasRenderableTissues(annotation),
                      },
                    },
                    [
                      _c("label", { staticClass: "vks-ge-legend-checkbox" }, [
                        _c("input", {
                          staticClass: "vks-ge-legend-input",
                          style: {
                            accentColor: _vm.legendSolidColor(annotation),
                          },
                          attrs: {
                            type: "checkbox",
                            disabled:
                              !_vm.hasRenderableTissues(annotation) &&
                              !_vm.isAnnotationSelected(annotation),
                          },
                          domProps: {
                            checked: _vm.isAnnotationSelected(annotation),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onToggleAnnotation(annotation, $event)
                            },
                          },
                        }),
                        _c("span", { staticClass: "vks-ge-legend-label" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.overviewAnnotationLabel(annotation)) +
                              " "
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._m(0),
            _c(
              "div",
              {
                staticClass: "vks-anno-workspace-plots",
                class: { "is-multi": _vm.showGePlotTitles },
                style: _vm.gePlotGridStyle,
              },
              _vm._l(_vm.gePlotPhenotypes, function (entry) {
                return _c(
                  "div",
                  {
                    key: entry.name,
                    staticClass: "vks-anno-workspace-plot-cell",
                  },
                  [
                    _vm.showGePlotTitles
                      ? _c(
                          "p",
                          { staticClass: "vks-anno-workspace-plot-title" },
                          [_vm._v(" " + _vm._s(entry.label) + " ")]
                        )
                      : _vm._e(),
                    _c("VariantSifterGlobalEnrichmentPlot", {
                      attrs: {
                        "global-enrichment-state": _vm.globalEnrichmentState,
                        "search-session": _vm.searchSession,
                        phenotype: entry.name,
                        "selected-annotations": _vm.selectedAnnotations,
                        "selected-tissues-by-annotation":
                          _vm.selectedTissuesByAnnotation,
                        utils: _vm.utils,
                      },
                      on: {
                        "toggle-tissue-selection":
                          _vm.onToggleTissueSelectionFromPlot,
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : [
            _c(
              "div",
              { ref: "trackPanel", staticClass: "vks-anno-workspace-panel" },
              [
                _c("canvas", {
                  ref: "canvas",
                  staticClass: "vks-anno-workspace-canvas",
                  class: {
                    "is-pannable": _vm.canPan,
                    "is-x-axis-hover": _vm.xAxisBandHover,
                    "is-region-hover": Boolean(_vm.hoveredRegion),
                  },
                  on: {
                    mousedown: _vm.onMouseDown,
                    mousemove: _vm.onMouseMove,
                    mouseout: _vm.onMouseOut,
                    mouseup: _vm.onMouseUp,
                    click: _vm.onCanvasClick,
                  },
                }),
                _c("VariantSifterZoomCenterMarker", {
                  attrs: {
                    "region-view-area": _vm.regionViewArea,
                    "region-zoom": _vm.regionZoom,
                    "plot-margin": _vm.margin,
                    placement: "track",
                  },
                  on: {
                    "update:regionViewArea": function ($event) {
                      return _vm.$emit("update:regionViewArea", $event)
                    },
                  },
                }),
                _vm.orderedSelectedTissues.length
                  ? _c(
                      "div",
                      { staticClass: "vks-anno-biosample-section" },
                      [
                        _c("p", { staticClass: "vks-anno-biosample-intro" }, [
                          _vm._v(
                            " Filter associated variants by location within regulatory regions annotated in specific tissue or cell types within the tissue categories selected above. "
                          ),
                        ]),
                        _vm._l(_vm.orderedSelectedTissues, function (tissue) {
                          return _c(
                            "div",
                            {
                              key: tissue,
                              staticClass: "vks-anno-biosample-group",
                            },
                            [
                              _vm.isBiosampleLoading(tissue)
                                ? _c(
                                    "p",
                                    { staticClass: "vks-anno-biosample-empty" },
                                    [
                                      _vm._v(
                                        " Loading biosample tracks for " +
                                          _vm._s(_vm.activeAnnotation) +
                                          " / " +
                                          _vm._s(tissue) +
                                          "… "
                                      ),
                                    ]
                                  )
                                : _vm.biosampleErrorForTissue(tissue)
                                ? _c(
                                    "p",
                                    { staticClass: "vks-anno-biosample-empty" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.biosampleErrorForTissue(tissue)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  )
                                : !_vm.biosampleGroupsForTissue(tissue).length
                                ? _c(
                                    "p",
                                    { staticClass: "vks-anno-biosample-empty" },
                                    [
                                      _vm._v(
                                        " No biosample regions found for " +
                                          _vm._s(_vm.activeAnnotation) +
                                          " / " +
                                          _vm._s(tissue) +
                                          ". "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c("canvas", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      !_vm.isBiosampleLoading(tissue) &&
                                      !_vm.biosampleErrorForTissue(tissue) &&
                                      _vm.biosampleGroupsForTissue(tissue)
                                        .length,
                                    expression:
                                      "\n                            !isBiosampleLoading(tissue) &&\n                                !biosampleErrorForTissue(tissue) &&\n                                biosampleGroupsForTissue(tissue).length\n                        ",
                                  },
                                ],
                                ref: "biosampleCanvas_" + tissue,
                                refInFor: true,
                                staticClass:
                                  "vks-anno-workspace-canvas vks-anno-biosample-canvas",
                                class: {
                                  "is-region-hover": Boolean(_vm.hoveredRegion),
                                  "is-x-axis-hover": _vm.xAxisBandHover,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onBiosampleCanvasClick(
                                      $event,
                                      tissue
                                    )
                                  },
                                  mousemove: function ($event) {
                                    return _vm.onBiosampleMouseMove(
                                      $event,
                                      tissue
                                    )
                                  },
                                  mouseout: _vm.onBiosampleMouseOut,
                                },
                              }),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.hoveredRegion
                  ? _c(
                      "div",
                      {
                        ref: "infoPanel",
                        staticClass: "vks-anno-workspace-info-panel",
                        attrs: { role: "status" },
                      },
                      [
                        _c(
                          "p",
                          { staticClass: "vks-anno-workspace-info-tissue" },
                          [_vm._v(_vm._s(_vm.hoveredRegion.tissue))]
                        ),
                        _vm.hoveredRegionBiosampleName
                          ? _c(
                              "p",
                              { staticClass: "vks-anno-workspace-info-line" },
                              [
                                _vm._v(
                                  " biosample: " +
                                    _vm._s(_vm.hoveredRegionBiosampleName) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "p",
                          { staticClass: "vks-anno-workspace-info-line" },
                          [_vm._v(" " + _vm._s(_vm.enrichedRegionLabel) + " ")]
                        ),
                        _vm.hoveredRegionHasMeta
                          ? [
                              _c(
                                "p",
                                { staticClass: "vks-anno-workspace-info-line" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.enrichedRegionDatasetLabel) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "p",
                                { staticClass: "vks-anno-workspace-info-line" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.enrichedRegionSourceLabel) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "p",
                                { staticClass: "vks-anno-workspace-info-line" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.enrichedRegionMethodLabel) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "p",
                                { staticClass: "vks-anno-workspace-info-line" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.enrichedRegionStateLabel) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          : [
                              _c(
                                "p",
                                { staticClass: "vks-anno-workspace-info-line" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.enrichedRegionStateLabel) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                      ],
                      2
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "vks-anno-workspace-plot-hint" }, [
      _vm._v(" Click a tissue point for options. Choose "),
      _c("strong", [_vm._v("Select tissue")]),
      _vm._v(" to add it on that annotation track and load biosample tracks. "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }